/**
 * FMR logo graphic inspired by ROOM MATE style:
 * - Two lines: "F" and "M" (top) with circular icon between, "R" (bottom)
 * - Circle contains people + house icon. Colors match theme for dark backgrounds.
 * Theme: #001d3d, #42a5f5 / #90caf9, white
 */
const FMRLogoGraphic = ({ size = 24, variant = "navbar", circular = false }) => {
  const isAuth = variant === "auth";
  const viewW = 100;
  const viewH = 48;
  const scale = isAuth ? size / viewH : size / 24;
  const w = circular ? size : (isAuth ? (size * viewW) / viewH : viewW * scale);
  const h = circular ? size : (isAuth ? size : viewH * scale);
  const viewBox = circular ? "0 0 100 100" : `0 0 ${viewW} ${viewH}`;
  const contentY = circular ? (100 - viewH) / 2 : 0;

  const content = (
    <g transform={circular ? `translate(0, ${contentY})` : undefined}>
      {/* Top line: F */}
      <text
        x={4}
        y={22}
        fontFamily="system-ui, Arial, sans-serif"
        fontSize={18}
        fontWeight="800"
        fill="#fff"
      >
        F
      </text>

      {/* Circular graphic (like O in ROOM) - people + house */}
      <g transform="translate(22, 4)">
        <circle cx={14} cy={14} r={13} fill="#42a5f5" stroke="rgba(255,255,255,0.5)" strokeWidth="1.2" />
        {/* Two people heads */}
        <circle cx={8} cy={12} r={2.5} fill="#001d3d" />
        <circle cx={20} cy={12} r={2.5} fill="#001d3d" />
        {/* Connection / handshake */}
        <path d="M10.5 13.5h7" stroke="#fff" strokeWidth="1" strokeLinecap="round" />
        {/* House */}
        <path
          d="M14 24l-4-3.5v2.2h2v2h4v-2h2v-2.2L14 24z"
          fill="#fff"
          stroke="#001d3d"
          strokeWidth="0.6"
          strokeLinejoin="round"
        />
      </g>

      {/* Top line: M */}
      <text
        x={52}
        y={22}
        fontFamily="system-ui, Arial, sans-serif"
        fontSize={18}
        fontWeight="800"
        fill="#fff"
      >
        M
      </text>

      {/* Bottom line: R (accent like MATE) */}
      <text
        x={72}
        y={42}
        fontFamily="system-ui, Arial, sans-serif"
        fontSize={16}
        fontWeight="800"
        fill="#90caf9"
      >
        R
      </text>
    </g>
  );

  return (
    <svg
      width={w}
      height={h}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      {content}
    </svg>
  );
};

export default FMRLogoGraphic;
